import { getImage } from '../utils/imageLoader';
import Render from '../render';
import { isBrowser } from '../utils/env';
import { getCanvasCreator } from '../canvas/createCanvas';
var id = 1;
var patternCanvas;
var Pattern = /** @class */ (function () {
    function Pattern(conf) {
        this.type = 'pattern';
        this.isPattern = true;
        this.option = conf;
        this.id = 'okee-render-pattern-' + id++;
    }
    Pattern.prototype.isReady = function () {
        return !!this._pattern;
    };
    Pattern.prototype.getCanvasContextStyle = function (ctx, onPatternReady) {
        var _this = this;
        var _a = this.option, image = _a.image, repeat = _a.repeat, element = _a.element, width = _a.width, height = _a.height;
        if (!this._pattern) {
            if (typeof image === 'string') {
                var result = getImage(image, this.id, function (ret) {
                    _this._pattern = ctx.createPattern(ret, repeat);
                    onPatternReady();
                });
                if (result) {
                    this._pattern = ctx.createPattern(result, repeat);
                    onPatternReady();
                }
            }
            else if (isBrowser && image instanceof HTMLImageElement) {
                if (image.complete) {
                    try {
                        this._pattern = ctx.createPattern(image, repeat);
                    }
                    catch (err) {
                        console.log(err);
                    }
                }
                else {
                    image.onload = function () {
                        try {
                            _this._pattern = ctx.createPattern(image, repeat);
                            _this._pattern.setTransform();
                            onPatternReady();
                        }
                        catch (err) {
                            onPatternReady();
                        }
                    };
                }
            }
            else if (element) {
                var canvas = (isBrowser && patternCanvas) ? patternCanvas : getCanvasCreator()(width, height);
                var render = new Render(canvas);
                var dpr_1 = isBrowser ? render.dpr : 1;
                isBrowser && render.resize(width, height);
                if (Array.isArray(element)) {
                    render.addAll(element);
                }
                else {
                    render.add(element);
                }
                render.refreshImmediately();
                render.dispose();
                if (isBrowser) {
                    var patterImage_1 = new Image();
                    var dataURL = canvas.toDataURL();
                    patterImage_1.onload = function () {
                        _this._pattern = ctx.createPattern(patterImage_1, 'repeat');
                        if (_this._pattern.setTransform) {
                            var matrix = new DOMMatrix([1 / dpr_1, 0, 0, 1 / dpr_1, 0, 0]);
                            _this._pattern.setTransform(matrix);
                        }
                        onPatternReady();
                    };
                    patterImage_1.src = dataURL;
                }
                else {
                    this._pattern = ctx.createPattern(canvas, 'repeat');
                    onPatternReady();
                }
            }
        }
        return this._pattern;
    };
    Pattern.prototype.getSVGNode = function () {
        var _this = this;
        var _a = this.option, image = _a.image, element = _a.element;
        if (image) {
            var _b = image, width = _b.width, height = _b.height, src = _b.src;
            return {
                svgTagName: 'pattern',
                svgAttr: {
                    id: this.id,
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                    patternUnits: 'userSpaceOnUse',
                },
                childNodes: [
                    {
                        svgTagName: 'image',
                        svgAttr: {
                            'xlink:href': src,
                            x: 0,
                            y: 0,
                            width: width,
                            height: height,
                        },
                    },
                ],
            };
        }
        if (element) {
            var nodes = Array.isArray(element) ? element : [element];
            var _c = this.option, width = _c.width, height = _c.height;
            return {
                svgTagName: 'pattern',
                svgAttr: {
                    id: this.id,
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                    patternUnits: 'userSpaceOnUse',
                },
                childNodes: nodes.map(function (node) { return _this._getNodeData(node); })
            };
        }
    };
    Pattern.prototype._getNodeData = function (node) {
        var _this = this;
        return {
            svgTagName: node.svgTagName,
            svgAttr: node.getSvgAttributes(),
            childNodes: node.childNodes.map(function (subNode) { return _this._getNodeData(subNode); }),
        };
    };
    return Pattern;
}());
export default Pattern;
